import React from 'react'
import { useMediaQuery } from '@material-ui/core'

export const useScreenSize = () => {
  const isDesktop = useMediaQuery('(min-width:600px)')
  const isMobile = useMediaQuery('(max-width:600px)')

  return { isDesktop, isMobile }
}
